import type { ExtractedMessages } from '@Infra/FetchLib/ApiError/extractMessages';

export type SubjectFieldNaturesFetchFailedAction = {
	type: 'SUBJECT_FIELD_NATURES_FETCH_FAILED';
	payload: ExtractedMessages;
};

export default (payload: ExtractedMessages): SubjectFieldNaturesFetchFailedAction => ({
	type: 'SUBJECT_FIELD_NATURES_FETCH_FAILED',
	payload,
});
